import Axios from '../../config/axios';
class UserService {
  getActiveUserList = (data) => {
    return Axios.get('/get-mac-users',{
      params:data
    } )
      .then(function (response) {
        const {
          data
        } = response;
        return data;
      }).catch((error) => {
        console.log(error);
      })
  }
  getInActiveUserList = (data) => {
 
    return Axios.get('/get-mac-users', {
      params:data
    })
      .then(function (response) {
        const {
          data
        } = response;
        return data;
      }).catch((error) => {
        console.log(error);
      })
  }

  manageActiveUser = (data) => {
    return Axios.post('/activate-mac-user', data)
      .then(function (response) {
        const {
          data
        } = response;
        return data;
      }).catch((error) => {
        console.log(error);
      })
  }
}
export default new UserService();